import React from 'react';

import { useMatchDatesStatus } from './useMatchDatesStatus';

import { MatchDatesStatusContext } from './context';

export const MatchDatesStatusProvider: React.FC = props => {
  const { status } = useMatchDatesStatus();

  const value = React.useMemo(() => ({
    status,
  }), [status]);

  return (
    <MatchDatesStatusContext.Provider value={value}>
      {props.children}
    </MatchDatesStatusContext.Provider>
  );
};